module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Deer-e0f954bafd50d93c41c60192b1eda43b.svg";